import { combineReducers } from "@reduxjs/toolkit";
import { bookmarksApi, commentApi, documentApi, favoritesApi } from "../services";

import { authApi } from "../services/auth";
import { suggestionApi } from "../services/suggestion";
import { tagsApi } from "../services/tags";
import { trigramsApi } from "../services/trigrams.ts";
import { usersApi } from "../services/users";
import { workspaceApi } from "../services/workspaces";
import appsReducer from "./slices/appsSlice";
import globalReducer from "./slices/globalSlice";

export const reducers = combineReducers({
  global: globalReducer,
  apps: appsReducer,
  [authApi.reducerPath]: authApi.reducer,
  [workspaceApi.reducerPath]: workspaceApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [tagsApi.reducerPath]: tagsApi.reducer,
  [suggestionApi.reducerPath]: suggestionApi.reducer,
  [documentApi.reducerPath]: documentApi.reducer,
  [bookmarksApi.reducerPath]: bookmarksApi.reducer,
  [commentApi.reducerPath]: commentApi.reducer,
  [favoritesApi.reducerPath]: favoritesApi.reducer,
  [trigramsApi.reducerPath]: trigramsApi.reducer,
});

export const middlewares: any[] = [
  authApi.middleware,
  usersApi.middleware,
  workspaceApi.middleware,
  tagsApi.middleware,
  suggestionApi.middleware,
  documentApi.middleware,
  bookmarksApi.middleware,
  commentApi.middleware,
  favoritesApi.middleware,
  trigramsApi.middleware,
];

export const whiteListReducers = [
  "global",
  "apps",
  // Add your persisted reducers here
];
